import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  FormLabel,
  TextField,
  Typography,
} from '@mui/material'
import axios from 'axios'
import { useFormik } from 'formik'
import { useState } from 'react'
import { toast } from 'react-toastify'
import * as yup from 'yup'
import Footer from '../Shared/Footer'
import SiteHeader from '../Shared/SiteHeader'

export const ContactUs = () => {
  const [loading, setLoading] = useState(false)

  const formik = useFormik({
    enableReinitialize: true,
    initialValues: { email: '', name: '', subject: '', description: '' },
    validationSchema: yup.object({
      email: yup.string().email('Email must be valid email').required('Email required'),
      name: yup.string().required('Name required'),
      subject: yup.string().required('Subject required'),
      description: yup.string(),
    }),
    onSubmit: async (values, { resetForm }) => {
      setLoading(true)
      try {
        await axios.post('https://api.3knots.com/api/v1/cms/contact-us', values)
        resetForm()
        toast.success('Thank you for reaching out! Your form has been submitted.')
      } catch {
        toast.error('Something went wrong. Please try again.')
      } finally {
        setLoading(false)
      }
    },
  })

  return (
    <div className='page-shell'>
      <SiteHeader />
      <Box className='page-content'>
        <Box className='page-container' sx={{ maxWidth: 640, mx: 'auto' }}>
          <Box className='section-header'>
            <Typography component='h1' className='section-title'>
              Contact Us
            </Typography>
            <Typography className='section-subtitle'>
              Connect with us — we&apos;re here to help.
            </Typography>
          </Box>

          <Box
            component='form'
            className='contact-form'
            onSubmit={formik.handleSubmit}
            sx={{ display: 'flex', flexDirection: 'column', gap: 2.5 }}
          >
            <FormControl>
              <FormLabel>Name</FormLabel>
              <TextField
                id='name'
                name='name'
                value={formik.values.name}
                error={!!(formik.touched.name && formik.errors?.name)}
                helperText={formik.touched?.name && formik.errors?.name}
                placeholder='Your name'
                onChange={formik.handleChange}
                fullWidth
              />
            </FormControl>

            <FormControl>
              <FormLabel>Email</FormLabel>
              <TextField
                id='email'
                name='email'
                value={formik.values.email}
                error={!!(formik.touched?.email && formik.errors.email)}
                helperText={formik.touched.email && formik.errors.email}
                placeholder='you@example.com'
                onChange={formik.handleChange}
                fullWidth
              />
            </FormControl>

            <FormControl>
              <FormLabel>Subject</FormLabel>
              <TextField
                id='subject'
                name='subject'
                value={formik.values.subject}
                error={!!(formik.touched.subject && formik.errors.subject)}
                helperText={formik.touched.subject && formik.errors.subject}
                placeholder='How can we help?'
                onChange={formik.handleChange}
                fullWidth
              />
            </FormControl>

            <FormControl>
              <FormLabel>Message</FormLabel>
              <TextField
                id='description'
                name='description'
                value={formik.values.description}
                error={!!(formik.touched.description && formik.errors.description)}
                helperText={formik.touched.description && formik.errors.description}
                placeholder='Tell us more...'
                rows={4}
                onChange={formik.handleChange}
                multiline
                fullWidth
              />
            </FormControl>

            <Button
              variant='contained'
              type='submit'
              disabled={loading}
              className='contact-form__submit'
            >
              {loading ? (
                <CircularProgress size={24} sx={{ color: '#fff' }} />
              ) : (
                'Send Message'
              )}
            </Button>
          </Box>
        </Box>
      </Box>
      <Footer />
    </div>
  )
}
